<nz-row [nzGutter]="[5, 5]">
  <nz-col
    *ngFor="let image of initialImages; trackBy: tackByImage"
    [nzXs]="grid.xs"
    [nzSm]="grid.sm"
    [nzMd]="grid.md"
    [nzLg]="grid.lg"
  >
    <app-lot-add-photo-images-sorter-item
      [image]="image"
      [lastIndex]="lasIndex"
      [index]="getIndex(image)"
      [isAuctionList]="isAuctionList(image)"
      [style.height.px]="itemHeightPx"
      (selected)="select($event)"
      (unselected)="unselect($event)"
    ></app-lot-add-photo-images-sorter-item>
  </nz-col>
</nz-row>
